import { render, staticRenderFns } from "./EmailNotificationEdit.vue?vue&type=template&id=72dec9ed&"
import script from "./EmailNotificationEdit.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports